// Shared helpers for ContentIQ uploaded assets — used by the ContentIQ
// workspace (Stage 1 sources) and the Content Assets page.
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

// Auth rides the axios interceptor, so downloads go blob -> object URL
// (a plain <a href> would arrive without the JWT).
export async function downloadAssetBlob(projectId, asset) {
  const res = await axios.get(`${API}/contentiq/projects/${projectId}/assets/${asset.id}/download`,
    { responseType: 'blob' });
  saveBlob(res.data, asset.title || asset.original_filename || 'download');
}

// Same blob->object-URL pattern for generated deliverables (.docx endpoints
// under /contentiq) — any authenticated GET that streams a file.
export async function downloadFileBlob(url, filename) {
  const res = await axios.get(url, { responseType: 'blob' });
  saveBlob(res.data, filename);
}

// Hand the browser a Blob as a named download — also used for files built in
// the browser (the sales enablement deck, utils/deck/renderDeck.js).
export function saveBlob(blob, filename) {
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}

export const MIME_LABELS = {
  'application/pdf': 'pdf', 'text/plain': 'txt', 'text/markdown': 'md', 'text/csv': 'csv',
  'image/png': 'png', 'image/jpeg': 'jpg',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
};

export const fmtSize = (b) => (b == null ? '—'
  : b >= 1024 * 1024 ? `${(b / (1024 * 1024)).toFixed(1)} MB`
  : `${Math.max(1, Math.round(b / 1024))} KB`);
